import type { Place } from '../domain/types';
import { RETURN_INTENT_LABELS, STATUS_LABELS } from '../domain/labels';

interface PlaceCardProps {
  place: Place;
}

export function PlaceCard({ place }: PlaceCardProps) {
  return (
    <article className="place-card">
      <a className="place-card__link" href={`#/place/${encodeURIComponent(place.id)}`}>
        <div className="place-card__top">
          <h3 className="place-card__name">{place.name}</h3>
          <span className={`status-badge ${place.status === 'visited' ? 'status-badge--visited' : ''}`}>
            {STATUS_LABELS[place.status]}
          </span>
        </div>
        {place.returnIntent ? <span className="intent-badge">{RETURN_INTENT_LABELS[place.returnIntent]}</span> : null}
        {place.tags.length > 0 ? (
          <div className="tags" aria-label="Теги">
            {place.tags.map((tag) => <span className="tag-chip" key={tag}>{tag}</span>)}
          </div>
        ) : null}
        {place.comment ? <p className="place-card__comment">{place.comment}</p> : null}
      </a>
    </article>
  );
}
